import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "live-bid-block" }

import PlaceBid from "@/components/_partials/PlaceBid.vue";
  import TimeLine from "@/components/_partials/TimeLine.vue";
  import { isScreenL } from "@/utils/media-size";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LiveBidBlock',
  emits: ["changeTab"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const changeTab = () => {
    emit("changeTab", "lock");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, {
      disabled: !_unref(isScreenL),
      to: ".mobile-place-bid-wrapper .mobile-place-bid-block",
      defer: ""
    }, [
      _createVNode(TimeLine),
      _createVNode(PlaceBid, {
        onChangeTab: _cache[0] || (_cache[0] = ($event: any) => (changeTab($event))),
        "is-mobile-block": _unref(isScreenL)
      }, null, 8, ["is-mobile-block"])
    ], 8, ["disabled"]))
  ]))
}
}

})